"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Base class for filters and operators DTOs.
 *
 * Created by Hayk.Andriasyan on 5/23/2017.
 */
var AbstractFilterElementDto = /** @class */ (function () {
    function AbstractFilterElementDto(type) {
        this.type = type;
    }
    return AbstractFilterElementDto;
}());
exports.AbstractFilterElementDto = AbstractFilterElementDto;
//# sourceMappingURL=abstract-filter-element-dto.js.map